export const INMET_HOUR_MS = 60 * 60 * 1000;

export function validInmetReadings(readings = [], now = new Date()) {
  const unique = new Map();
  for (const reading of readings) {
    const time = new Date(reading?.timestamp || '').getTime();
    if (!Number.isFinite(time) || time > now.getTime()) continue;
    if (!['temperature', 'humidity', 'rain_mm', 'wind_speed', 'pressure', 'radiation', 'wind_gust', 'wind_direction', 'temp_max', 'temp_min']
      .some(key => Number.isFinite(reading[key]))) continue;
    unique.set(time, reading);
  }
  return [...unique.entries()].sort(([a], [b]) => a - b).map(([, reading]) => reading);
}

export function inmetSummary(snapshot, now = new Date()) {
  const readings = validInmetReadings(snapshot?.leituras, now);
  const latest = readings[readings.length - 1] || null;
  const recentRain = readings.filter(reading => {
    const age = now.getTime() - new Date(reading.timestamp).getTime();
    return age < 24 * INMET_HOUR_MS && Number.isFinite(reading.rain_mm) && reading.rain_mm >= 0;
  });
  const rainHours = recentRain.length;
  return {
    latest,
    stale: latest ? now.getTime() - new Date(latest.timestamp).getTime() > 3 * INMET_HOUR_MS : false,
    collectionDelayed: snapshot?.coletado_em
      ? now.getTime() - new Date(snapshot.coletado_em).getTime() > 2 * INMET_HOUR_MS
      : false,
    rain24h: rainHours ? Number(recentRain.reduce((sum, reading) => sum + reading.rain_mm, 0).toFixed(2)) : null,
    rainHours,
    rainComplete: rainHours === 24,
  };
}

export function inmetHistory48h(snapshot, now = new Date()) {
  const readings = new Map(validInmetReadings(snapshot?.leituras, now)
    .map(reading => [new Date(reading.timestamp).getTime(), reading]));
  const end = Math.floor(now.getTime() / INMET_HOUR_MS) * INMET_HOUR_MS;
  return Array.from({ length: 48 }, (_, index) => {
    const time = end - (47 - index) * INMET_HOUR_MS;
    return readings.get(time) || {
      timestamp: new Date(time).toISOString(),
      temperature: null, humidity: null, rain_mm: null, wind_speed: null,
    };
  });
}

export function formatInmetTime(value) {
  const date = new Date(value || '');
  if (!Number.isFinite(date.getTime())) return 'Não disponível';
  return date.toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
  });
}

export function formatInmetValue(value, unit = '', maximumFractionDigits = 1) {
  return Number.isFinite(value)
    ? `${value.toLocaleString('pt-BR', { maximumFractionDigits })}${unit}`
    : '—';
}
